import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

function UpgradeSuccess() {
  const [status, setStatus] = useState('loading');
  const [userEmail, setUserEmail] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    const email = params.get('email'); 

    if (sessionId) {
      setStatus('success');
      if (email) {
        setUserEmail(email);
      }
    }
  }, [location]);

  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  return (
    <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-6">
                <h1 className='pt-4 px-0 pb-0 m-0'>Hey there, Heavyweight hero!</h1>
                  <h2 className='py-2 px-0 m-0'>
                  {userEmail ? (
                    <>
                      Your Nudgemail account at {userEmail} has been upgraded. That means more power, flexibility, and an undeniable boost to your organizational swagger. Go ahead and start adding attachments to all the Nudges your heart desires.
                      <br /><br />
                      If you have questions (or want to say hi), visit the <a href="/contact" className="textLink">Contact page</a>. Thanks for your support.
                    </>
                  ) : (
                    <>
                      Your Nudgemail account has been upgraded. That means more power, flexibility, and an undeniable boost to your organizational swagger. Go ahead and start adding attachments to all the Nudges your heart desires.
                      <br /><br />
                      If you have questions (or want to say hi), visit our <a href="/contact" className="textLink">Contact page</a>. Thanks for your support.
                    </>
                  )}
                  </h2>
              </div>
            </div>
          </div>
          
          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
      </section>
  );
}

export default UpgradeSuccess;